import { initialTableShow } from 'utils/settings';
import { env } from 'env';

export const NETWORK_ROLLOUT_SELECTION_LIMIT = parseInt(
  env.REACT_APP_NETWORK_ROLLOUT_SELECTION_LIMIT || '40'
);

export const DEFAULT_SELECTION: string[] = [];

export const GRID_DETAIL_PANEL_FIELD = 'gateWays';
export const GRID_DETAIL_PANEL_ROW_ID = 'gatewayId';
export const NETWORK_WITH_FAILED_INSTANCES = 'Network with Failed instances';

// ACTIONS

export const ACTIONS_URL_PREFIX = '/network_rollout/rollout/';
export enum ACTIONS_URL_POSTFIX {
  CALC = 'calc',
  RUN = 'run'
}
export enum ACTIONS {
  UPGRADE_NETWORK = 'force-network-upgrade',
  UPGRADE_GATEWAY = 'force-gateway-upgrade',
  AUTOMATIC_UPDATE = 'network-automatic-update'
}
export enum ACTIONS_TEXTS {
  'force-network-upgrade' = 'network upgrade',
  'force-gateway-upgrade' = 'gateway upgrade',
  'network-automatic-update' = 'update user services'
}

export type ModalDetails = {
  networks?: number;
  gws?: number;
  action?: ACTIONS;
  batchId?: string;
};

export const defaultModalDetails: ModalDetails = {
  networks: undefined,
  gws: undefined,
  action: undefined,
  batchId: undefined
};

// FILTERS

export interface NetworkRolloutFilter {
  networkGwMinVersion: never[];
  networkVersion: never[];
  providerRegionName: never[];
  regionCountry: never[];
  featureAdoption: never[];
  'tunnels.tunnelType': never[];
  status: never[];
  partnerType: never[];
  firstPaymentDate: {
    startDate: null;
    endDate: null;
  };
  firstInvoiceAt: {
    startDate: null;
    endDate: null;
  };
  nextBillingDate: {
    startDate: null;
    endDate: null;
  };
  companySize: never[];
  arr: {
    from: string;
    to: string;
  };
  arrChangedFrom: string;
  arrChangedTo: string;
  plan: never[];
  billingCycle: never[];
  healthStatus: never[];
  industry: never[];
  customerSuccessEngineer: never[];
  accountManager: never[];
  not_networkGwMinVersion: never[];
  not_providerRegionName: never[];
  statusFailed: string;
  networkId: never[];
  customerId: never[];
}

export const defaultNavigation = {
  fieldName: 'datetime',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const defaultFilters = {
  search: '',
  networkGwMinVersion: [],
  networkVersion: [],
  providerRegionName: [],
  regionCountry: [],
  featureAdoption: [],
  'tunnels.tunnelType': [],
  status: [],
  partnerType: [],
  firstPaymentDate: { startDate: null, endDate: null },
  firstInvoiceAt: { startDate: null, endDate: null },
  nextBillingDate: { startDate: null, endDate: null },
  companySize: [],
  arr: {
    from: '',
    to: ''
  },
  arrChangedFrom: '',
  arrChangedTo: '',
  plan: [],
  billingCycle: [],
  healthStatus: [],
  industry: [],
  customerSuccessEngineer: [],
  accountManager: [],
  not_networkGwMinVersion: [],
  not_providerRegionName: [],
  statusFailed: '',
  networkId: [],
  customerId: [],
  ...defaultNavigation
};
